import { useEffect, useRef } from 'react';
import { addLayer, removeLayer } from './addingLayers/AddVoltagesLayers';

const useSync3DLayers = ({
    wfsLayers,
    setWfsLayers,
    setWmsLayers,
    setHoverInfo,
    handleClickInfo,
    viewState,
    setViewState,
    setOverlay,
    id_terenske_jedinice,
    netType = "niskonaponska"
}) => {
    const lastIs3DRef = useRef(viewState.is3D);

    useEffect(() => {
        if (lastIs3DRef.current === viewState.is3D) return;
        lastIs3DRef.current = viewState.is3D;

        const syncLayers = async () => {
            const layersToUpdate = ["trafo_stanice", "stubovi", "mjerna_mjesta", "vod", "dionica"];

            for (const layerName of layersToUpdate) {
                // ako sloj koristi suffix (netType)
                const hasSuffix = ["stubovi", "vod", "dionica"].includes(layerName);
                const layerId = hasSuffix ? `${layerName}-${netType}` : layerName;

                const existingLayer = wfsLayers.find(layer => layer.id.startsWith(layerId));
                if (existingLayer) {
                    // brišemo sve slojeve koji odgovaraju
                    setWfsLayers(prev => removeLayer(prev, layerName, netType));
                    setWmsLayers(prev => removeLayer(prev, layerName, netType));

                    const newLayer = await addLayer(
                        layerName,
                        setHoverInfo,
                        handleClickInfo,
                        null,
                        setWmsLayers,
                        netType,
                        viewState,
                        setViewState,
                        false,
                        setOverlay,
                        id_terenske_jedinice,
                        wfsLayers
                    );

                    if (!newLayer || (Array.isArray(newLayer) && newLayer.length === 0)) continue;

                    const normalized = Array.isArray(newLayer) ? newLayer : [newLayer];
                    const filtered = normalized.filter(l => l); // ukloni null/undefined

                    if (filtered.length > 0) {
                        setWfsLayers(prev => [...prev, ...filtered]);
                    }

                }
            }
        };

        syncLayers();
    }, [viewState.is3D]);
};

export default useSync3DLayers;
